import {
  useState,
  useEffect,
  useCallback,
} from "react";

type OrderStatesType = "asc" | "desc" | "normal";

export const useOrder = (data: Sentinel.Processes.GetAllProcessesResponse[] = []) => {
  const [order, setOrder] = useState(data);
  const [sortState, setSortState] = useState<{ field: string; order: OrderStatesType } | null>(null);

  useEffect(() => {
    setOrder(data);
  }, [data]);

  const handleColumnOrder = useCallback((field: string, newOrder: OrderStatesType) => {
    setSortState({ field, order: newOrder });

    if (newOrder === "normal") {
      setOrder([...data].sort((a, b) => a.id - b.id));
      return;
    }

    const sorted = [...data].sort((a, b) => {
      const valorA = String(a[field] ?? "").toLowerCase();
      const valorB = String(b[field] ?? "").toLowerCase();

      return newOrder === "asc"
        ? valorA.localeCompare(valorB)
        : valorB.localeCompare(valorA);
    });

    setOrder(sorted);
  }, [data]);

  const getColumnOrder = useCallback((field: string): OrderStatesType => {
    return sortState?.field === field ? sortState.order : "normal";
  }, [sortState]);

  return { 
    order, 
    handleColumnOrder,
    getColumnOrder,
  };
}